// Angular imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { classToPlain, plainToClass } from 'class-transformer';
// Constant imports
import { URLConstants } from '../../_constants/url-constants';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
// Model imports
import { AnnouncementsResultDto } from '../../_models/announcements-result-dto';
import { AnnouncementEditorResultDto } from '../../_models/announcement-editor-result-dto';
import { AnnouncementAccessResultDto } from '../../_models/announcement-access-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PortalAnnouncementService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getAnnouncementCount() {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}/unread/count`;
        return this.httpClient.get(url).pipe(map((response) => response.count));
    }
    getAnnouncementAccess() {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}/access`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(AnnouncementAccessResultDto, response)));
    }
    getAnnouncements(category) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}/${category}`;
        return this.httpClient.get(url).pipe(map((response) => plainToClass(AnnouncementsResultDto, response)));
    }
    getExpiredAnnouncements(expiredFromDate, expiredToDate) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}/expired?expiredFromDate=${dateJSONTransformer(expiredFromDate)}&expiredToDate=${dateJSONTransformer(expiredToDate)}`;
        return this.httpClient.get(url).pipe(map((response) => plainToClass(AnnouncementsResultDto, response)));
    }
    getAnnouncementEditor(announcementId) {
        let url = `${URLConstants.ccPortalAnnouncementApiUrl}/editor`;
        if (announcementId > 0) {
            url = `${url}?announcementId=${announcementId}`;
        }
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(AnnouncementEditorResultDto, response)));
    }
    saveAnnouncement(params) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}`;
        return this.httpClient.post(url, classToPlain(params));
    }
    updateAnnouncement(params) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}`;
        return this.httpClient.put(url, classToPlain(params));
    }
    deleteAnnouncement(params) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}`;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: classToPlain(params)
        };
        return this.httpClient.delete(url, options);
    }
    markAsReadAnnouncements(param) {
        const url = `${URLConstants.ccPortalAnnouncementApiUrl}/markasread`;
        return this.httpClient.put(url, classToPlain(param));
    }
}
PortalAnnouncementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PortalAnnouncementService_Factory() { return new PortalAnnouncementService(i0.ɵɵinject(i1.HttpClient)); }, token: PortalAnnouncementService, providedIn: "root" });
